<template>
  <img
    src="@/assets/img/svg/prime-video-logo.svg"
    alt="Prime Video"
  />
</template>
